var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommonService } from 'common/store/service';
import { Membre } from 'membre/classes/Membre.class';
import { Alerte } from '../Alerte.class';
/**
 * Chaque objet est un commentaire émis par un utilisateur
 */
export class Commentaire {
    /**
     * Constructeur de l'objet Comments
     * @param row array contenant les données de l'objet
     */
    constructor(row) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        this.idCommentaire = (_a = row === null || row === void 0 ? void 0 : row.idCommentaire) !== null && _a !== void 0 ? _a : null;
        this.author = (row === null || row === void 0 ? void 0 : row.author) ? new Membre(row === null || row === void 0 ? void 0 : row.author.infoPublic) : null;
        this.text = (_b = row === null || row === void 0 ? void 0 : row.text) !== null && _b !== void 0 ? _b : '';
        this.section = (_c = row === null || row === void 0 ? void 0 : row.section) !== null && _c !== void 0 ? _c : null;
        this.publishDate = (_d = row === null || row === void 0 ? void 0 : row.publishDate) !== null && _d !== void 0 ? _d : Math.floor(Date.now() / 1000);
        this.idParent = (_e = row === null || row === void 0 ? void 0 : row.idParent) !== null && _e !== void 0 ? _e : null;
        this.currentLiked = (_f = row === null || row === void 0 ? void 0 : row.currentLiked) !== null && _f !== void 0 ? _f : null;
        this.likesAmount = (_g = row === null || row === void 0 ? void 0 : row.likesAmount) !== null && _g !== void 0 ? _g : null;
        this.answersAmount = (_h = row === null || row === void 0 ? void 0 : row.answersAmount) !== null && _h !== void 0 ? _h : null;
        this.modifDate = (_j = row === null || row === void 0 ? void 0 : row.modifDate) !== null && _j !== void 0 ? _j : null;
        this.alerte = (row === null || row === void 0 ? void 0 : row.alerte) ? new Alerte(row === null || row === void 0 ? void 0 : row.alerte) : null;
    }
    /**
     * Ajoute un commentaire en BDD sur la section choisi et sur un potentiel commentaire parent.
     * @return true si l'ajout a réussi, false sinon
     */
    post() {
        return __awaiter(this, void 0, void 0, function* () {
            return CommonService.postComment(this);
        });
    }
    /**
     * Edite un commentaire
     * @return true si l'édition a réussi, false sinon
     */
    edit() {
        return __awaiter(this, void 0, void 0, function* () {
            return CommonService.editComment(this);
        });
    }
    /**
     * Supprime un commentaire
     * @param idRaison raison de la suppression (optionnel)
     * @return true si la suppression a réussi, false sinon
     */
    delete(idRaison) {
        return __awaiter(this, void 0, void 0, function* () {
            return CommonService.deleteComment(this.idCommentaire, idRaison);
        });
    }
    /**
     * Like un commentaire
     * @return True si le like a été ajouté au commentaire
     */
    like() {
        return __awaiter(this, void 0, void 0, function* () {
            return CommonService.likeComment(this.idCommentaire);
        });
    }
    /**
     * Enlève le like d'un commentaire
     * @return True si le like a été enlevé du commentaire
     */
    unlike() {
        return __awaiter(this, void 0, void 0, function* () {
            return CommonService.unlikeComment(this.idCommentaire);
        });
    }
    /**
     * Retourne la section dans laquelle apparaît le commentaire et l'id de l'objet auquel est rattaché le commentaire
     * @return [0] La section
     * 			[1] L'id de l'objet auquel est rattaché le commentaire
     */
    formatSectionToString() {
        return this.section.split('_');
    }
    toRaw() {
        var _a;
        return {
            author: this.author.toRaw(),
            alerte: (_a = this.alerte) === null || _a === void 0 ? void 0 : _a.toRaw(),
            idCommentaire: this.idCommentaire,
            text: this.text,
            section: this.section,
            publishDate: this.publishDate,
            idParent: this.idParent,
            currentLiked: this.currentLiked,
            likesAmount: this.likesAmount,
            answersAmount: this.answersAmount,
            modifDate: this.modifDate,
        };
    }
}
//# sourceMappingURL=data:application/json;base64,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